import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from "@components/components.module";
import { VirtualScrollerModule } from "ngx-virtual-scroller";
import {
    StrainConfigurationCardComponent
} from "@app/strain/common/components/strain-configuration-card/strain-configuration-card.component";
import { ToolModule } from "@app/tool/tool.module";
import { DrawingCanvasComponent } from "@app/strain/common/components/drawing-canvas/drawing-canvas.component";
import {
    StrainProcessScheduledCardComponent
} from "@app/strain/common/components/strain-process-steps/strain-process-scheduled-card/strain-process-scheduled-card.component";
import {
    StrainMeasurementGageDetailsFormComponent
// tslint:disable-next-line:max-line-length
} from "@app/strain/common/components/measurement-forms/strain-measurement-gage-details-form/strain-measurement-gage-details-form.component";
import {
    StrainMeasurementDetailsFormComponent
} from "@app/strain/common/components/measurement-forms/strain-measurement-details-form/strain-measurement-details-form.component";
import {
    StrainMeasurementImagesFormComponent
} from "@app/strain/common/components/measurement-forms/strain-measurement-images-form/strain-measurement-images-form.component";
import {
    StrainMeasurementGageMountingFormComponent
} from "@app/strain/common/components/measurement-forms/strain-measurement-gage-mounting-form/strain-measurement-gage-mounting-form.component";
import {
    StrainMeasurementChartsFormComponent
} from "@app/strain/common/components/measurement-forms/strain-measurement-charts-form/strain-measurement-charts-form.component";

import { StrainMeasurementImageComponent } from './components/strain-measurement-image/strain-measurement-image.component';
import { ExcelPasteTableComponent } from './components/excel-paste-table/excel-paste-table.component';
import { ExcelChartPasteComponent } from './components/excel-chart-paste/excel-chart-paste.component';
import {
    StrainGageConfigurationModalComponent
} from './components/measurement-forms/strain-gage-configuration-modal/strain-gage-configuration-modal.component';
import {
    StrainGageConfigurationFormComponent
} from "@app/strain/common/components/measurement-forms/strain-gage-configuration-form/strain-gage-configuration-form.component";
import {
    StrainSampleBoardLoadModalComponent
} from '@app/strain/common/components/measurement-forms/strain-sample-board-load-modal/strain-sample-board-load-modal.component';
import { StrainReportOverviewComponent } from './components/strain-report-overview/strain-report-overview.component';
import { StrainPcbFormComponent } from "@app/strain/common/components/strain-pcb-form/strain-pcb-form.component";
import {
    StrainReportSelectionFormComponent
} from "@app/strain/common/components/measurement-forms/strain-report-selection-form/strain-report-selection-form.component";
import { TooltipModule } from "primeng/tooltip";
import {
    SampleBoardMaterialScanItemComponent
} from "@app/strain/common/components/sample-board-material-scan-item/sample-board-material-scan-item.component";
import {
    SampleBoardMaterialScanListComponent
} from "@app/strain/common/components/sample-board-material-scan-list/sample-board-material-scan-list.component";
import {SampleBoardRecipeComponent} from "@app/strain/common/components/sample-board-recipe/sample-board-recipe.component";
import {SampleBoardRecipeItemComponent} from "@app/strain/common/components/sample-board-recipe-item/sample-board-recipe-item.component";
import {SampleBoardRegistryItemsComponent} from "@app/strain/common/components/sample-board-registry-items/sample-board-registry-items.component";
import {SampleBoardRegistryItemComponent} from "@app/strain/common/components/sample-board-registry-item/sample-board-registry-item.component";
import {
    SampleBoardStocListComponent
} from "@app/strain/common/components/sample-board-stoc-list/sample-board-stoc-list.component";
import {
    SampleBoardStocListItemComponent
} from "@app/strain/common/components/sample-board-stoc-list-item/sample-board-stoc-list-item.component";
import {
    StrainProcessOwnersTagsComponent
} from "@app/strain/common/components/strain-process-owners-tags/strain-process-owners-tags.component";
import { MeasurementExcelImportService } from '@app/strain/planning/service/measurement-excel-import.service';
import {
    StrainEquivalentPartNumbersModalComponent
} from "@app/strain/common/components/strain-equivalent-part-numbers-modal/strain-equivalent-part-numbers-modal.component";
import {
    StrainUpdateMainPartNumberModalComponent
} from "@app/strain/common/components/strain-update-main-part-number-modal/strain-update-main-part-number-modal.component";

@NgModule({
    imports: [
        TranslateModule,
        VirtualScrollerModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule,
        ComponentsModule,
        ToolModule
    ],
    declarations: [
        StrainConfigurationCardComponent,
        DrawingCanvasComponent,
        StrainGageConfigurationModalComponent,
        StrainGageConfigurationFormComponent,
        StrainSampleBoardLoadModalComponent,
        StrainProcessScheduledCardComponent,
        StrainMeasurementGageDetailsFormComponent,
        StrainMeasurementDetailsFormComponent,
        StrainMeasurementImagesFormComponent,
        StrainMeasurementGageMountingFormComponent,
        StrainMeasurementChartsFormComponent,
        StrainMeasurementImageComponent,
        ExcelPasteTableComponent,
        ExcelChartPasteComponent,
        StrainReportOverviewComponent,
        StrainPcbFormComponent,
        StrainReportSelectionFormComponent,
        SampleBoardMaterialScanItemComponent,
        SampleBoardMaterialScanListComponent,
        SampleBoardRecipeComponent,
        SampleBoardRecipeItemComponent,
        SampleBoardRegistryItemsComponent,
        SampleBoardRegistryItemComponent,
        SampleBoardStocListComponent,
        SampleBoardStocListItemComponent,
        StrainProcessOwnersTagsComponent,
        StrainEquivalentPartNumbersModalComponent,
        StrainUpdateMainPartNumberModalComponent
    ],
    exports: [
        TranslateModule,
        VirtualScrollerModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule,
        ComponentsModule,
        ToolModule,
        StrainConfigurationCardComponent,
        DrawingCanvasComponent,
        StrainProcessScheduledCardComponent,
        StrainMeasurementGageDetailsFormComponent,
        StrainMeasurementDetailsFormComponent,
        StrainMeasurementImagesFormComponent,
        StrainMeasurementGageMountingFormComponent,
        StrainMeasurementChartsFormComponent,
        StrainGageConfigurationModalComponent,
        StrainGageConfigurationFormComponent,
        StrainSampleBoardLoadModalComponent,
        ExcelPasteTableComponent,
        ExcelChartPasteComponent,
        StrainReportOverviewComponent,
        StrainPcbFormComponent,
        StrainReportSelectionFormComponent,
        SampleBoardMaterialScanItemComponent,
        SampleBoardMaterialScanListComponent,
        SampleBoardStocListComponent,
        SampleBoardStocListItemComponent,
        SampleBoardRecipeComponent,
        SampleBoardRecipeItemComponent,
        SampleBoardRegistryItemsComponent,
        SampleBoardRegistryItemComponent,
        StrainProcessOwnersTagsComponent,
        StrainEquivalentPartNumbersModalComponent,
        StrainUpdateMainPartNumberModalComponent
    ],
    providers: [
        MeasurementExcelImportService
    ]
})
export class StrainCommonModule {
}
